<div
  class="px-3 bg-[#1A43590F] pt-2 pb-3 rounded-[10px] cursor-pointer snap-normal snap-end"
  (click)="toggleCheck()"
  (mouseenter)="this.isContentHover = true"
  (mouseleave)="this.isContentHover = false"
  [ngClass]="{ 'border border-secondary-normal': isChecked }"
>
  <div class="flex justify-between">
    <h3 class="mb-[10px] font-montserratMedium text-xs text-primary-strong">
      <span
        class="rounded-full inline-flex h-2 w-2 mr-1"
        [ngClass]="{ 'bg-tertiary-normal': !viewed, 'bg-[#93A6B7]': viewed }"
      ></span>
      {{ this.notificationDate | date: "dd / MM / yyyy" }}
    </h3>
    <div class="group grid size-4 grid-cols-1">
      <input
        [checked]="isChecked"
        type="checkbox"
        class="col-start-1 cursor-pointer row-start-1 appearance-none rounded bg-none hover:border hover:border-[#135f8b] checked:border checked:border-[#135F8B] checked:bg-none indeterminate:border-[#135F8B] indeterminate:bg-primary-normal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-normal disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
        [ngClass]="{ 'border border-[#135f8b6b]': isContentHover }"
      />
      <svg
        class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-secondary-normal group-has-[:disabled]:stroke-gray-950/25"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          class="opacity-0 group-has-[:checked]:opacity-100"
          d="M3 8L6 11L11 3.5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          class="opacity-0 group-has-[:indeterminate]:opacity-100"
          d="M3 7H11"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
  <h2 class="mb-3 font-freightSansProSemibold text-base text-primary-normal">
    {{ this.title }}
  </h2>
  <p class="font-montserratMedium text-xs text-primary-strong">
    {{ this.body }}
  </p>
</div>
